export default {"src":"/_next/static/media/eth-slateus.4ac61d8c.svg","height":100,"width":100};